/**
 * Generated by orval v6.31.0 🍺
 * Do not edit manually.
 * Bondsmith Savings Exchange Operation Portal APIs
 * OpenAPI spec version: 0.1
 */

export type WithdrawalType = typeof WithdrawalType[keyof typeof WithdrawalType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const WithdrawalType = {
  FULL: 'FULL',
  PARTIAL: 'PARTIAL',
} as const;
